import { render, staticRenderFns } from "./StatusChangePanel.vue?vue&type=template&id=529cd258&scoped=true"
import script from "./StatusChangePanel.vue?vue&type=script&lang=js"
export * from "./StatusChangePanel.vue?vue&type=script&lang=js"
import style0 from "./StatusChangePanel.vue?vue&type=style&index=0&id=529cd258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529cd258",
  null
  
)

export default component.exports